import { mapActions, mapMutations } from 'vuex'
import { EventBus, Events } from '../lib/Eventbus'

export default {
  methods: {
    ...mapActions({
      clearFlights: 'socket.io/clearFlights'
    }),
    ...mapMutations({
      setSelectedAirport: 'socket.io/setSelectedAirport'
    }),
    selectAirport(val) {
      if (val != null) {
        // Leave existing channels
        const airportStore = this.$store.state.settings.settings.airport

        this.clearFlights()

        if (airportStore.current) {
          const leavingIataCode = airportStore.current.iata_code

          if (this.$socket) {
            this.$socket.client.emit('leave', leavingIataCode + '-FLT')
            this.$socket.client.emit('leave', leavingIataCode + '-POS')
          }
        }

        this.$store.commit('settings/setCurrentAirport', val)
        this.setSelectedAirport(val.iata_code)
        EventBus.$emit(Events.airportSelected, val)

        if (this.$socket) {
          this.$socket.client.emit('join', val.iata_code + '-FLT')
          this.$socket.client.emit('join', val.iata_code + '-POS')
        }
      }
    }
  }
}
